module.exports = __webpack_public_path__ + "static/WS_appflows_fisica_1-5c8a0279d9f366188a79ab58a1cee86a.gif";